import { MeterFieldProps } from "../../../types/salesDocuments.types";
import { useMeterContext } from "../meterContext";
import { fitChargeMeasurements } from "../salesDocuments.constants";

export const FitChargeComponent: React.FC<MeterFieldProps> = ({ meter, hidden }) => {
  const ctx = useMeterContext();

  if (hidden) return null;
  return (
    <div className="sales-doc-field mb-3">
      <hr className="sales-doc-divider" />
      <label htmlFor={`meter-${meter.id.toString()}-fit-charge`}>FIT Charge</label>
      <div className="input-group">
        <input
          type="number"
          min="0"
          step="0.00001"
          className="form-control"
          id={`meter-${meter.id.toString()}-fit-charge`}
          value={ctx.fitCharge}
          onChange={(e) => {
            ctx.setFitCharge(e.target.value);
          }}
        />
        <select
          className="form-select"
          style={{ maxWidth: "110px" }}
          value={ctx.fitChargeUnit}
          onChange={(e) => {
            ctx.setFitChargeUnit(e.target.value);
          }}
        >
          {fitChargeMeasurements.map((unit) => (
            <option key={unit} value={unit}>
              {unit}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
